export class uploadAvatarOpenController{
  /**
   *
   * @param $uploadAvatar
   */
  constructor(
    $uploadAvatar
  ){
    'ngInject';
    this.$uploadAvatar = $uploadAvatar;
  }
  /**
   *
   * @param formUploadAvatar
   * @param $event
   */
  $onSubmit(formUploadAvatar, $event){
    this.$uploadAvatar.create( $event.target[0].files )
      .then(() => this.usersUpdate.user.uris.Avatar = `${this.usersUpdate.user.uris.Avatar}?timestamp=${Number(new Date())}`)
      .then(() => formUploadAvatar.$submitted = false );
  }
}


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/upload-avatar/upload-avatar.controllers.js
 **/